
import { Component, Vue } from "vue-property-decorator";
@Component
export default class TheFooter extends Vue {
  private redirectContactUs() {
    window.location.href = "http://lareina.cl/atencion-vecino/";
  }
}
